module.exports = __webpack_public_path__ + "static/img/badge_logo.110e0e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/badge_logo.png
// module id = sbQ4
// module chunks = 1